import React from 'react';
import {useSelector} from 'react-redux';
import {
  selectExtendedGameResults,
  selectGameResults,
  selectGameType,
  selectIsRankedMatch,
  selectPlayers
} from '../../redux/reducers/sharedStateReducer/selectors';
import './GameEndContent.css';
import GameEndPlayerInfo from "./GameEndPlayerInfo/GameEndPlayerInfo";
import {getPlayerById} from "../../utils/players/getPlayerById";
import {GAME_TYPES} from "../../constants/game";
import {getGameResultsPlaces} from "../../utils/gameEnd/compareGameResults";

const GameEndContent = ({isCompactMode = false}) => {
  const gameResults = useSelector(selectGameResults);
  const extendedGameResults = useSelector(selectExtendedGameResults);
  const players = useSelector(selectPlayers);
  const gameType = useSelector(selectGameType);
  // Лобби есть только у участников матча; при просмотре ЗАПИСИ его нет,
  // поэтому признак дублируется в состоянии партии (см. startGame)
  const lobbyIsRanked = useSelector((state) => state.private.lobby?.isRanked);
  const matchIsRanked = useSelector(selectIsRankedMatch);
  const isRanked = Boolean(lobbyIsRanked || matchIsRanked);

  const extendedById = new Map(
    (extendedGameResults || []).map((result) => [result.id, result])
  );

  const places = getGameResultsPlaces(gameResults || []);

  return (
    <div className="game-end-content">
      <div className="game-end-content_players-container">
        {(gameResults || []).map((player, index) => {
          const fullPlayerState = getPlayerById(players, player.id);
          const extended = extendedById.get(player.id);
          const finalPlayer = {
            ...player,
            ...fullPlayerState,
            ...extended,
          };
          // Синтетические игроки сетевых игр не должны выдаваться пометкой бота
          // в модалке конца игры — иконка бота остается только в локальных
          // партиях. REPLAY воспроизводит именно сетевой (ONLINE/рейтинговый)
          // матч, поэтому здесь группируется с ним, а не с LOCAL: та же
          // прозрачность (точнее, ее отсутствие) должна сохраняться и при
          // просмотре записи, даже для админа
          if (gameType !== GAME_TYPES.LOCAL) {
            finalPlayer.isBot = false;
          }
          // «Явных» ботов рейтинговых матчей это не касается: их пометка
          // публична по замыслу (см. src/configs/visibleRankedBots.js) и
          // остается на месте во всех режимах, включая реплей
          return (
            <GameEndPlayerInfo
              player={finalPlayer} key={index} index={index} place={places[index]} isRanked={isRanked} isCompactMode={isCompactMode}
            />
          )
        })}
      </div>
    </div>
  );
};

export default GameEndContent;
